

import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import TopMenus from "../../shared/TopMenus"
import AdminAracPunishQuery from "../../adminAraclar/AdminAracPunishQuery"
import AdminAracYetkiBelgesiSorgula from "../../adminAraclar/AdminAracYetkiBelgesiSorgula"
import AdminAracMuayeneSorgula from "../../adminAraclar/AdminAracMuayeneSorgula"
import AdminAracDetails from "../../adminAraclar/AdminAracDetails.jsx"
import AdminAracTruckDocs from "../../adminAraclar/AdminAracTruckDocs.jsx"
import AdminAracTrailerDocs from "../../adminAraclar/AdminAracTrailerDocs.jsx"

const ModalContainer = styled.div`
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    z-index: 26;
    padding-top: 80px;

    .modal{
        width: 1400px;
        height: 800px;
        max-height: 800px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 20px;
            padding-bottom: 0;
            width: calc(100% - 80px);
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;

            .top-menu-container{
                width: 100%;
                height: 40px;
            }

            .main-content{
                width: 100%;
                height: calc(100% - 40px);
                margin-top: 20px;
            }
        }
    }
`

const menuList = [
    {
        id: 1,
        text: "Araç Bilgileri"
    },
    {
        id: 2,
        text: "Araç Belgeleri"
    },
    {
        id: 3,
        text: "Ceza Sorgula"
    },
    {
        id: 4,
        text: "Yetki Belgesi Sorgula"
    },
    {
        id: 5,
        text: "Muayene Sorgula"
    },
]

const AdminAracDetayModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const {selectAdminArac} = useSelector(state => state.admin2)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [activeMenuId, setActiveMenuId] = useState(1)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Detayları"}/>
        <div className="content">
            <div className="top-menu-container">
                <TopMenus activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} menuList={menuList}/>
            </div>
            <div className="main-content">
                {
                    activeMenuId === 1 &&
                    <AdminAracDetails/>
                    // <div>Yapılıyor</div>
                }
                {
                    (activeMenuId === 2 && selectAdminArac.type === "truck") ?
                    <AdminAracTruckDocs/>
                    : 
                    (activeMenuId === 2 && selectAdminArac.type === "trailer") ? 
                    <AdminAracTrailerDocs/>: null
                }
                {
                    activeMenuId === 3 &&
                    <AdminAracPunishQuery/>
                }
                {
                    activeMenuId === 4 &&
                    <AdminAracYetkiBelgesiSorgula/>
                }
                {
                    activeMenuId === 5 &&
                    <AdminAracMuayeneSorgula/>
                }
            </div>
        </div>

       
    </div>
</ModalContainer>
  )
}

export default AdminAracDetayModal